const FOOTER_LOGOS = [
  { src: "/images/footer-logo-1.svg", alt: "logo 1" },
  { src: "/images/footer-logo-2.svg", alt: "logo 2" },
  { src: "/images/footer-logo-3.svg", alt: "logo 3" },
  { src: "/images/footer-logo-4.svg", alt: "logo 4" },
  { src: "/images/footer-logo-5.svg", alt: "logo 5" },
];

const Footer = () => {
  return (
    <>
      <div className="bg-[#0F0F0F]">
        <div className="container p-5 mx-auto flex items-center justify-between">
          <div className="flex flex-col gap-5">
            <button className="bg-[#54C6F9] w-[81px] md:w-[158px] h-[28px] md:h-[54px] rounded-[45px] text-white font-kalameh text-sm md:text-[20px]">
              صفحه اصلی
            </button>
            <button className="bg-[#A466FF] w-[81px] md:w-[158px] h-[28px] md:h-[54px] rounded-[45px] text-white font-kalameh text-sm md:text-[20px]">
              مقالات
            </button>
          </div>
          <div className="flex flex-col items-start justify-start gap-2.5">
            <img
              src="/images/footer-pic.svg"
              alt="logo"
              className="w-[180px] h-auto hidden lg:block"
            />
            <p className="text-white font-kalameh text-sm md:text-[20px]">
              استودیو صداسازی آکادمی واک
            </p>
            <p className="text-white font-kalameh text-sm md:text-[20px]">
              قم، پردیسان، جنب باشگاه شهاب دانش
            </p>
            <p className="text-white font-kalameh text-sm md:text-[20px]">
              تماس: 09105039130
            </p>
            <div dir="ltr" className="flex items-center justify-start gap-2.5">
              {Array.from({ length: 5 }).map((_, index) => {
                const logo = FOOTER_LOGOS[index];
                return (
                  <div
                    key={index}
                    className="flex items-center justify-center w-[19px] md:w-[49px] h-[19px] md:h-[49px] bg-[#D9D9D9] rounded-full"
                  >
                    {logo && (
                      <img
                        src={logo.src}
                        alt={logo.alt}
                        className="w-[13px] md:w-[33px] h-[13px] md:h-[33px]"
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          <img
            src="/images/logo3.svg"
            alt="logo"
            className="h-full w-[297px] hidden lg:block"
          />
        </div>
      </div>
      <div className="h-[47px] bg-[#54C6F9] flex items-center justify-center">
        <p className="text-white font-kalameh text-[15px]">
          کلیه حقوق این وبسایت متعلق به آکادمی واک است.
        </p>
      </div>
    </>
  );
};

export default Footer;
